import React, { useEffect, useState } from 'react';
import { fetchPriceRegister } from '../recordsApi';

const euro = (value) => (value == null ? '—' : `€${Math.round(value).toLocaleString('en-IE')}`);

// Price register sales for one Eircode, newest to oldest. onLoaded fires once the content has changed size.
export default function PriceRegisterList({ eircode, onLoaded }) {
  const [state, setState] = useState({ entries: null, error: null });

  useEffect(() => {
    let cancelled = false;
    setState({ entries: null, error: null });
    fetchPriceRegister(eircode).then(
      (entries) => !cancelled && setState({ entries, error: null }),
      (error) => !cancelled && setState({ entries: null, error })
    );
    return () => { cancelled = true; };
  }, [eircode]);

  useEffect(() => {
    if (onLoaded && (state.entries || state.error)) onLoaded();
  }, [state, onLoaded]);

  const { entries, error } = state;
  const showAddress = entries && new Set(entries.map((e) => e.address)).size > 1; // shared Eircode: say which property
  const anyNotFullPrice = entries && entries.some((e) => e.not_full_market_price);

  return (
    <div className="pr-box">
      <div className="pr-title">Price register{entries ? ` (${entries.length})` : ''}</div>
      {!entries && !error && <div className="pr-note">Loading…</div>}
      {error && <div className="pr-note negative-value">Could not load price register</div>}
      {entries && entries.length === 0 && <div className="pr-note">No entries for this Eircode</div>}
      {entries && entries.length > 0 && (
        <ul className="pr-list">
          {entries.map((e) => (
            <li key={e.id || `${e.date}-${e.price}-${e.address}`}>
              <div className="pr-row">
                <span className="pr-date">{e.date || 'No date'}</span>
                <span className="pr-price">{euro(e.price)}{e.not_full_market_price ? ' *' : ''}</span>
              </div>
              {showAddress && <div className="pr-address">{e.address}</div>}
            </li>
          ))}
        </ul>
      )}
      {anyNotFullPrice && <div className="pr-note">* not full market price</div>}
    </div>
  );
}
